/**
 * Page with start rating and thank you at the end
 * 
 * TRY: https://www.aaron-powell.com/posts/2019-09-23-recursive-settimeout-with-react-hooks/
 *      https://stackoverflow.com/questions/57023074/why-is-the-cleanup-function-from-useeffect-called-on-every-render
 * 
 */

import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from 'react-router-dom';
import { Trans } from "react-i18next";
import i18n from  "./../../Documental/Localization/i18n.js";
import TopNav from  '../PatientApp/TopNav';
import Modal from  '../Modal/Modal';

import { DomainResource } from './../../Documental/DomainResource/DomainResource';

import starImg from './start.svg';
import starImg2 from './start-selected.svg';

var timerProceedPoll = null;
var timerProceedPollCnt = 0;
var rateLocalResourceId = null; // getMappedServerIdFromLocalId


/**
 * Resource used to submit rating to erver is QuestionnaireResponse
 * Build it. 
 * 
 * @param integer rating
 * @returns 
 */
const createRatingResourceJson = ( rating ) => {
  let json = {
    "resourceType": "QuestionnaireResponse",
    "status": "completed",
    "questionnaire":"Questionnaire/user-feedback-v1", 
    "item": [
    ]
  };

  json.item.push( {
    "linkId": "APPRATE.webapp.rating",
    "text": "Web app rating",
    "answer": [
      {
        "valueInteger": rating
      }
    ]
  } );

  if( typeof navigator !== "undefined" ){
    let os = "unknown";
    if (navigator.appVersion.indexOf('Win') != -1) {os = 'Windows'};
    if (navigator.appVersion.indexOf('Mac') != -1) {os = 'MacOS'};
    if (navigator.appVersion.indexOf('X11') != -1) {os = 'UNIX'};
    if (navigator.appVersion.indexOf('Linux') != -1) {os = 'Linux'};

    json.item.push( {
      "linkId": "APPRATE.os",
      "text": "Client OS",
      "answer": [
        {
          "valueString": os
        }
      ]
    } );
  }

  
  let items = window.appEntityStore.getAllResourcesBySearchParams({
    "resourceType" : "Patient"
  });
  
  // thereshould be only 1 patient resource in store
  for( var ii in items ){
    let patientId = items[ ii ].getId();
    let pid = patientId.getResourceId();
    
    json.subject = {
      "reference" : "Patient/" + pid
    }
  }

  /**
    json.item.push({
      "linkId": "APPRATE.2",
      "text": "Question",
      "answer": [
        {
          "valueCoding": {
            "system": "system url",
            "code": "1",
            "display": "Yes"
          }
        }
      ]
    });
  */
  
  return json;
}

const isGivenRatingSynced = () => {

  let serverId = window.appEntityStore.getMappedServerIdFromLocalId( rateLocalResourceId );
  
  //if( window.appEntityStore.isRecourceSyncingById( rateLocalResourceId ) ){
  //}
  
  if( serverId === null ){
    return false;
  }

  return true;
}


function RatePage() {
  const navigate = useNavigate();
  
  const [ proceedClicked, setProceedClicked ] = useState( false );
  const [ selectedStarRate, setSelectedStarRate ] = useState( -1 );

  const handleSkipClick = () => {
    navigate( './../finished' );
    return;
  }
  
  
  /**
   * Select rating, but don't send it away yet. Just 
   * visually update stars to show what rating was clicked. 
   * 
   * 154.24 
   * 
   * @param integer inp 
   */
  const handleSelectRateClick = (inp) => {
    setSelectedStarRate(inp);
  }


  /**
   * Actully start sending selected rating to the server
   *   - construct resource via rate will be transported
   *   - send to server
   *   - poll when sending is done (synced)
   *   - redirect to thank you page
   * 
   */
  const handleRateConfirmClick = () => {
    let json = createRatingResourceJson( selectedStarRate );

    var domainResource = new DomainResource( "QuestionnaireResponse" );
    domainResource.setRawResourceObject( json );
    domainResource.setResourceMeta( window.appEntityStore.getResourceMetaWithOnlyNewSourceUrl( 'QuestionnaireResponse' ) );
    rateLocalResourceId = window.appEntityStore.createLocalResourceId( "QuestionnaireResponse" );
    domainResource.setId( rateLocalResourceId );
    window.appEntityStore.saveResource( domainResource );
    
    setProceedClicked( true );
  }

  const pollProceedClick = () => {
    if ( timerProceedPoll !== null) {
      clearTimeout( timerProceedPoll );
    }
    
    timerProceedPollCnt++;

    let synced = isGivenRatingSynced();

    // safety net - if no response from server - proceed anyway
    if( timerProceedPollCnt > 20 || synced ){
      navigate( './../finished' );
      return;
    }
    
    timerProceedPoll = setTimeout(function () {
      pollProceedClick();
    }, 250 );
  }
  
  if( proceedClicked && timerProceedPoll === null ){
    pollProceedClick();
  }

  let buttonProceedClasses = "btn next mb-6";
  if( proceedClicked ){
    buttonProceedClasses = "btn loading-full mb-6";
  }

  let lang = i18n.language;

  let star1Src = starImg;
  let star2Src = starImg;
  let star3Src = starImg;
  let star4Src = starImg;
  let star5Src = starImg;

  if( selectedStarRate > 0 ){
    star1Src = starImg2;
  }

  if( selectedStarRate > 1 ){
    star2Src = starImg2;
  }

  if( selectedStarRate > 2 ){
    star3Src = starImg2;
  }

  if( selectedStarRate > 3 ){
    star4Src = starImg2;
  }

  if( selectedStarRate > 4 ){
    star5Src = starImg2;
  }

  return (
    <div>
      <div className="app-page finished">
        <br />
        <br />
        <br />
        <div>
          <h1 className="mb-8"><Trans>How would you rate your experience with our product</Trans>?</h1>
        </div>
        <br />
        <br />
        <br />
        <div className="star-grid grid grid-flow-col grid-cols-5 gap-x-4 mb-6">
          <div className="star-wrap"  onClick={ function(){ handleSelectRateClick( 1 ) } } >
            <img  className="icon-star" src={star1Src} />
          </div>
          <div className="star-wrap" onClick={ function(){ handleSelectRateClick( 2 ) } } >
            <img  className="icon-star" src={star2Src} />
          </div>
          <div className="star-wrap" onClick={ function(){ handleSelectRateClick( 3 ) } } >
            <img  className="icon-star" src={star3Src} />
          </div>
          <div className="star-wrap" onClick={ function(){ handleSelectRateClick( 4 ) } } >
            <img  className="icon-star" src={star4Src} />
          </div>
          <div className="star-wrap" onClick={ function(){ handleSelectRateClick( 5 ) } } >
            <img  className="icon-star" src={star5Src} />
          </div>
        </div>

        <div className="app-fragment pull-bottom-fixed">
          <div className="content-text">
            
            </div>
            
          {( selectedStarRate > -1 ) && (
            <span className="btn full-width   mb-6" onClick={handleRateConfirmClick}>
              <Trans>Rate</Trans>
            </span>
          )}
          
          <span className="btn full-width btn-skip  dark disabled" onClick={handleSkipClick}>
            <Trans>Skip</Trans>
          </span>

        </div>

      </div>
    </div>
  );
}

export default RatePage;